export const REQUEST_REMOVE_CHILD_MESSAGE =
  'Ваш запрос принят и направлен на обработку. Оператор ЦОПП при необходимости свяжется с вами.';
export const REMOVE_CHILD_MESSAGE =
  'Профиль обучающегося удален. Если это произошло по ошибке и вы хотите восстановить данные, пожалуйста, свяжитесь с администратором.';
export const ERROR_CHILD_MESSAGE =
  'У нас произошел сбой в работе оборудования. Почитайте, пожалуйста, статьи, а позже попробуйте еще раз!';
export const CONFIRM_DELETE_TEXT =
  'Настоящим вы направляете запрос в службу поддержки ЦОПП на удаление данных о ребенке, после обработки запроса данные будут удалены. Вы уверены?';
export const CERT_ERROR_MESSAGE = {
  certErrorText:
    'Ваше заявление принято. Регламентный срок обработки — 10 рабочих дней.',
};
export const CONFIRM_DELETE_HEADER = 'Удаление записи о ребенке';



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/const.ts